import app from 'flarum/forum/app';
export default function canStartPrivateDiscussion(recipient) {
  return app.session.user && app.session.user.id() !== recipient.id() && app.forum.attribute('canStartPrivateDiscussion') && (!recipient.blocksPd() || app.forum.attribute('canStartPrivateDiscussionWithBlockers'));
}
flarum.reg.add('fof-byobu', 'forum/helpers/canStartPrivateDiscussion', canStartPrivateDiscussion);